import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { StatusCodes } from 'http-status-codes';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthenticationService {
  private nativeWindow = inject<Window>('nativeWindow' as any);

  isErrorResponseUnauthorized(response: HttpErrorResponse): boolean {
    return response.status === StatusCodes.UNAUTHORIZED;
  }

  isErrorResponseForbidden(response: HttpErrorResponse): boolean {
    return response.status === StatusCodes.FORBIDDEN;
  }

  login(path: string): void {
    if (!path.includes('access-denied')) {
      const referrer = document.referrer || '';
      if (referrer) {
        sessionStorage.setItem('preLoginReferrer', referrer);
      }

      const login = new URL(environment.backendBaseUrl + '/loginRedirect');
      login.searchParams.append('refUrl', path);

      this.nativeWindow.location.href = login.href;
    }
  }

  logout(): void {
    const logout = new URL(environment.backendBaseUrl + '/logout');
    const form = document.createElement('form');
    document.body.appendChild(form);
    form.method = 'POST';
    form.action = logout.href;
    form.submit();
    document.body.removeChild(form);
  }
}
